import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.slice(1));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    apiClient
      .post("/auth/session", { session_id: sessionId }, { withCredentials: true })
      .then((r) => {
        // Clear hash, send to admin
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: r.data } });
      })
      .catch(() => navigate("/admin/login", { replace: true }));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-zinc-500 font-mono text-xs tracking-[0.3em] uppercase">
      Authenticating...
    </div>
  );
}
